// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JGbI","col":"styles_col__2NBWx","actions":"styles_actions__2eNv1","conflict":"styles_conflict__WUn-C"};